import React from 'react'

const HelloText = () => {
  return (
    <div className='hello-text'>
        <p><span style={{color:"#4D4D4D"}}>İyi günler</span>, Metin 👋</p>
        <p>Tüm İşlemlerini Buradan Gerçekleştirebilirsin</p>
    </div>
  )
}

export default HelloText